<template>
  <div v-if="bcPaths" :class="['breadcrumbs', 'px-2xl',_subdomain!=false ? 'no-menu-mode' :'', pageReady ? 'ready' : '']">
    <div class="breadcrumbs--links">

      <router-link :to="`/${localePath}`" v-text="localize('Home')" ></router-link>

      <!-- todo: remove the list if none-main page -->

      <template v-if="bcPaths && isMainSite">
        <!-- Main site -->
        <router-link v-for="item in bcPaths"
                    :key="item.path"
                    :to="item.path"
                    v-text="item.label"
                    :class="[item.css]">
        </router-link>
      </template>
      <template v-else-if="bcPaths && _subdomain!=false">
        <!-- subdomain pages -->
        <router-link v-for="item in pathesForSubdomain" 
                    :key="item.path"
                    :to="item.path"
                    v-text="item.label"
                    :class="[item.css]">
        </router-link>
      </template>

      <a v-else disabled v-text="localize(currentPageTitle)"></a>
    </div>

    <!-- <div
      class="social-share"
      @mouseleave="socialMouseLeaveHandler"
      @mouseenter="socialMouseEnterHandler"
    >
      <social-sharing
        :url="currentUrl || 'https://www.mis-implants.com'"
        :title="metaPageTitle || 'Mis Website'"
        :description="metaPageDescription || 'MIS Website'"
        quote="Make it simple | MIS Dental Implants"
        :hashtags="metaPageKeywords || 'mis,dental implants, prosthetics'"
        twitter-user="vuejs"
        inline-template
        v-show="activeSocial"
      >
        <transition name="fade-child" appear>
          <div class="inline-block social-wrap">
            <network network="linkedin" key="1">
              <i class="fab fa-linkedin"></i>
            </network>
            <network network="facebook" key="2">
              <i class="fab fa-facebook"></i>
            </network>
          </div>
        </transition>
      </social-sharing>
      <a
        :class="['ml-s', activeSocial ? 'active' : '']"
        @click.prevent="toggleSocial"
        href="#p"
        ><i class="far fa-share-alt"></i
      ></a>
    </div> -->
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { subdomain } from "@/utils";
export default {
  // head: {
  //   // To use "this" in the component, it is necessary to return the object through a function
  //   title: function() {
  //     return {
  //       inner: this.metaPageTitle
  //     };
  //   },
  //   meta: function() {
  //     return [
  //       { name: "description", content: this.metaPageDescription, id: "desc" },
  //       { name: "keywords", content: this.metaPageKeywords, id: "key" }
  //     ];
  //   }
  // },
  data() {
    return {
      activeSocial: false,
      _subdomain:''
    };
  },
  computed: {
    ...mapState(["pageLayoutData", "pageReady"]),
    ...mapGetters(["localePath"]),
    isMainSite()
    {
      if(this._subdomain==false || this._subdomain.length<2){
        return true;
      }else{
        return false;
      }
    },
    pathesForSubdomain()
    {
      if(this.bcPaths.length>2)
      {        
        return _.slice(this.bcPaths,2);////remove 2 first items 
      }else{
          return this.bcPaths;
      }
        
    },
    currentPageTitle() {
      return this.pageLayoutData
        ? this.pageLayoutData.title
        : _.last(this.splitPath) || null;
    },
    metaPageTitle() {
      return this.pageLayoutData &&
        this.pageLayoutData.meta &&
        this.pageLayoutData.meta.page_title
        ? this.pageLayoutData.meta.page_title
        : "MIS - Dental Implants Technology";
    },
    bcChildren() 
    {
      // Get localized breadcrumb information...
      let bc;
      //if(this.pageLayoutData==null)
      //{
        //display default breadcrumbs
        //var bcd = 
        //[{"cached":false,"use":true,"id":-1,"version":0,"pid":0,"max_count":0,"index":-1,"order":0,"media_type_id":0,
          //"title":"User Collection","url":"","isChildContent":false,"isFeatured":false,"children":[],"event_start_year":0,"event_start_month":0}];
          //return bcd;
      //}

      //alert(this.pageLayoutData);
      if (this.pageLayoutData) {        
        /*  FIND the breadcrumbs data
            in the pageLayoutData
        */
        bc = _.find(this.pageLayoutData.children, { type: "breadcrumbs" });
        if (bc) {
          return bc.children;
        }else
        {
          
          if(this.pageLayoutData.breadcrumbs)
          {
            //this is for catalog product page case:
            return this.pageLayoutData.breadcrumbs;
          }
        }
      }
      return null;
    },
    metaPageDescription() {
      return this.pageLayoutData &&
        this.pageLayoutData.meta &&
        this.pageLayoutData.meta.meta_description
        ? this.pageLayoutData.meta.meta_description
        : "MIS - Dental Implants Technology";
    },
    metaPageKeywords() {
      return this.pageLayoutData &&
        this.pageLayoutData.meta &&
        this.pageLayoutData.meta.meta_keywords
        ? this.pageLayoutData.meta.meta_keywords
        : "MIS, dental implants, c1, v3";
    },
    currentUrl() {
      return window.location.href;
    },
    locale() {
      let params = this.$route.params;
      return params.locale || this.$defaultLang;
    },
    localerx() {
      return new RegExp(`/${this.locale}/`);
    },
    splitPath() {
      let path = this.$route.path;
      return path.split("/").filter(el => !!el && el !== this.locale);
    },
    bcPaths() {
      // let routepath = this.$route.path,
      let children = this.bcChildren;
      if (children && children.length) {
        let bc = children.map(item => {
          return {
            label: item.title,
            path: item.url,
            css: item.title.length > 45 ? "long-txt" : ""
          };
        });
        return bc;
      }

      return null;
    }
  },
  created() {
    this._subdomain = subdomain();
    console.log("_subdomain >> "+this._subdomain);
  },
  mounted() {
    this._subdomain = subdomain();
    console.log("_subdomain >> "+this._subdomain);
    //alert(subdomain());
  },

  methods: {
    toggleSocial() {
      console.log("TOGGLE SOCIAL");
      this.$set(this, "activeSocial", !this.activeSocial);
    },
    socialMouseLeaveHandler() {
      setTimeout(
        function() {
          this.activeSocial = false;
        }.bind(this),
        400
      );
    },
    socialMouseEnterHandler() {
      this.activeSocial = true;
    },
    beforeEnter: function(el) {
      el.style.opacity = 0;
      el.style.transform = "translateY(20%)";
    },
    enter: function(el, done) {
      let lapse = 120,
        delay = el.dataset.index * lapse;
      setTimeout(function() {
        el.animate(
          {
            opacity: [0, 1],
            transform: ["translateY(20%)", "translateY(0)"],
            easing: "cubic-bezier(0.175, 0.885, 0.32, 1.275)"
          },
          { duration: 600, fill: "forwards" }
        ).onfinish = function() {
          done();
        };
      }, delay);
    },
    leave: function(el, done) {
      el.style.opacity = 0;
      el.style.transform = "translateY(120%)";
      done();
    }
  }
};
</script>
<style lang="stylus">
.fade-child
	&-enter-active
	&-leave-active
    transition opacity 0.5s ease-out-cubic, transform 0.5s ease-out-cubic
    &:nth-child(1)
      transition opacity 0.5s ease-out-cubic, transform 0.5s ease-out-cubic
    &:nth-child(2)
      transition opacity 0.5s 1s ease-out-cubic, transform 0.5s 1s ease-out-cubic
    &:nth-child(3)
      transition opacity 0.5s ease-out-cubic, transform 0.5s ease-out-cubic
	&-enter
	&-leave-to
    opacity 0
    transform translateY(200%) scale(0)
	&-enter-to
	&-leave
    opacity 1
    transform translateY(0) scale(1)
.breadcrumbs
  background gray_0
  min-height 56px
  padding 10px 0
  border-bottom 1px solid #e3e3e3
  _flex(row,wrap,center, space-between)
  position sticky
  top 123px
  z-index 100
  overflow hidden
  +below(815px)
    top 93px
  &--links
    a
    a:visited
      opacity 0
      color gray_5
      hoverize(gray_6, color)
      transition opacity 0.2s ease-out
      text-transform capitalize
      font-size responsive 14px 16px
      &:first-letter
        text-transform capitalize
      &:not(:last-child):after
        content '/'
        margin 0 4px
      &:last-child
        cursor default
        color gray_8
        &.long-txt
          text-overflow ellipsis
          max-width 280px
          white-space nowrap
          overflow hidden
          position relative
          transition max-width 0.2s ease-out
          &:after
            content ''
            position absolute
            top 0
            bottom 0
            right 0
            width 70%
            background linear-gradient(to left, gray_0 40%, rgba(gray_0, 0))
            transition width 0.4s ease-out
          &:hover
            max-width 700px
            &:after
              width 0%
  &.ready .breadcrumbs--links a
    &:nth-child(1)
      transition opacity 0.9s ease-out
    &:nth-child(2)
      transition opacity 0.9s 0.1s ease-out-cubic
    &:nth-child(3)
      transition opacity 0.9s 0.2s ease-out-cubic
    &:nth-child(4)
      transition opacity 0.9s 0.3s ease-out-cubic, max-width 0.2s ease-out
    opacity 1
  .social-share
    _flex(row, wrap, center, flex-end)
    a
    a:visited
      position relative
      display block
      color gray_7
      font-size 22px
      transform translateZ(0) scale(0.8)
      backface-visibility hidden
      appearance none
      transition transform 0.3s ease-out-back, opacity 0.3s ease-out
      opacity 0.7
      will-change opacity, transform
      &:hover
      &.active
        transform translateZ(0) scale(1.1)
        opacity 1
    *
    *:active
    *:focus
      outline none
    span
      cursor pointer
      margin 0 3px
      color gray_5
      transition color 0.3s ease-out
      &:hover
        color gray_7
    .social-wrap
      span
        animation fadeUp
        animation-duration 0.3s
        animation-iteration-count 1
        animation-delay 0s
        animation-timing-function ease-out-cubic
        animation-fill-mode forwards
        animation-direction normal
        display inline-block
        transform translateY(300%)
        &:first-child
          animation-delay 0.1s


@keyframes fadeUp
  0%
    transform translateY(300%)
  100%
    transform translateY(0)
</style>

<style scoped>
  .no-menu-mode
  {
    top: 40px !important;
    position: fixed;
    width: 100%;    
  }
</style>
